import ConfigurableText from './_configurable-text.js'

export default {
  name: 'PotentialReturns',
  values: {
    style: {
      base: {
        margin: 0,
        textStyle: {
          $mixin: [
            {
              configSet: ConfigurableText,
            },
          ],
        },
      },
      disabled: {
        margin: 0,
        textStyle: {
          $mixin: [
            {
              configSet: ConfigurableText,
            },
          ],
        },
      },
      label: {
        margin: '0 4px 0 0',
        textStyle: {
          $mixin: [
            {
              configSet: ConfigurableText,
            },
          ],
        },
      },
      labelDisabled: {
        margin: '0 4px 0 0',
        textStyle: {
          $mixin: [
            {
              configSet: ConfigurableText,
            },
          ],
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
